import '../product-card/product-card-display';
import '../search/search-results';

import { html, PropertyValueMap } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { connect } from 'pwa-helpers';
import { BaseComponent } from '../../features/base-component/base-component';
import store from '../../store/store';
import { booleanConverter } from '../../common/converters';
import { ViewType, ViewTypeLabel } from '../search/interfaces/search.interface';
import { performSearch } from '../search/thunks/search.thunk';
import { selectView } from '../search/store/search.selector';
import { mapCatalog } from '../../common/utils/util';
import { StoreState } from '../../store/store.interface';


/**
 * An element to perform plp search using program code
 *
 * @csspart programCode - program code on which search result will be performed.
 *
 */
@customElement('mhecomm-plp-search-results')
export class PlpSearchResults extends connect(store)(BaseComponent) {
  @property({ converter: booleanConverter })
  autoLoad = false;

  @property()
  catalog = 'seg-product';

  @property()
  programCode = '';

  /**
   * The number of results to load. Only used when autoLoad is true.
   */
  @property({ type: Number })
  pageSize = 10;

  @state()
  view: ViewType = ViewTypeLabel.LIST;

  protected firstUpdated(_changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>): void {
    super.firstUpdated(_changedProperties);
    if (this.autoLoad) {
      store.dispatch(
        performSearch({
          searchTerms: '',
          catalog: mapCatalog(this.catalog),
          pageLength: this.pageSize,
          start: 1,
          facets: true,
          store: '',
          fieldValueFilter: {},
          excludeFacetName: undefined,
          sortBy: 'plp_copyright_desc',
          isPlpSearch:true,
          filter: this.programCode
            ? {
                type: 'FieldFilter',
                paramName: 'PROGRAM_CODE',
                value: this.programCode,
                conditionalOperator: 'EQ',
              }
            : undefined,
        })
      );
    }
  }

  renderComp() {
    return html`
      <mhecomm-search-results
        data-automation-id="plp_product_list"
        id="plp_product_list"
        variation="large-card"
        view="${this.view}"
      >
      </mhecomm-search-results>
    `;
  }

  stateChanged(state: StoreState) {
    const viewType = selectView(state);
    this.view = viewType ? viewType : ViewTypeLabel.LIST;
  }
}
declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-plp-search-results': PlpSearchResults;
  }
}
